"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
interface QueryProviderProps {
  children: React.ReactNode;
}
const QueryProvider = props => {
  const $ = _c(4);
  const [client] = React.useState(_temp);
  const children = props.children;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = process.env.NODE_ENV === "development" ? <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" /> : null;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children || $[2] !== client) {
    t1 = <QueryClientProvider client={client}>{children}{t0}</QueryClientProvider>;
    $[1] = children;
    $[2] = client;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default QueryProvider;
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 600000,
        retry: false
      }
    }
  });
}